// React imports
import React from 'react';
import classnames from 'classnames';
import { Modal } from '@codametrix/ui-components';
import { Conditional } from '@codametrix/ui-components';
import './styles/index.scss';
/**
 * State for the Case Comment component
 */
type CaseCommentState = {
  comment: string;
  validationMessage: string;
};

const DEFAULT_PROPS: Partial<CMxCommonApp.CaseCommentProps> = {
  title: 'Add case comment',
  minLength: 5,
  maxLength: 1024,
  numberOfRows: 4,
  submitLabel: 'Comment',
  mandatoryComment: true,
  actionOnlyNoComment: false
};

class CaseComment extends React.Component<
  CMxCommonApp.CaseCommentProps,
  CaseCommentState
> {
  static displayName = 'CaseComment';
  /**
   * Constructor method for class CaseComment
   * @param {CMxCommonApp.CaseCommentProps} props - Props object passed to CaseComment component
   */
  constructor(props: CMxCommonApp.CaseCommentProps) {
    super(props);
    this.state = {
      comment: '',
      validationMessage: ''
    };
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.submitComment = this.submitComment.bind(this);
    this.cancelComment = this.cancelComment.bind(this);
  }
  /**
   * Method to handle the change event for text area element
   * @param {Object} event - Event object
   */
  handleCommentChange(event) {
    this.setState({ comment: event.target.value });
  }

  /**
   * Method to handle submit comment validation
   */
  handleValidation() {
    const comment = this.state.comment;
    if (this.props.mandatoryComment && (!comment || comment.trim() === '')) {
      this.setState({ validationMessage: 'Comment cannot be empty!' });
    } else if (comment.length < this.props.minLength) {
      this.setState({
        validationMessage: `Comment should have minimum ${this.props.maxLength} characters`
      });
    }
    return this.state.validationMessage ? false : true;
  }
  /**
   * Method to submit case comment
   */
  submitComment() {
    if (this.handleValidation()) {
      this.props.onSubmit(this.state.comment);
    }
  }

  /**
   * Method to cancel case comment
   */
  cancelComment() {
    this.props.onCancel();
  }

  render() {
    const props: CMxCommonApp.CaseCommentProps = {
      ...DEFAULT_PROPS,
      ...this.props
    };
    const {
      title,
      subtitle,
      maxLength,
      numberOfRows,
      submitLabel,
      actionOnlyNoComment
    } = props;
    const validationMessage = this.state.validationMessage;
    const placeholder =
      (props.placeholder ? props.placeholder : 'Enter comments') +
      (props.mandatoryComment ? '' : ' (optional)');
    return (
      <Modal title={title} onClose={this.cancelComment}>
        <form className="case-comment" onSubmit={(e) => e.preventDefault()}>
          {subtitle && <p className="case-comment-subtitle">{subtitle}</p>}
          {validationMessage && (
            <p className="case-comment-validation">{validationMessage}</p>
          )}
          <Conditional every={[!actionOnlyNoComment]}>
            <>
              <textarea
                className="case-comment-textarea cmx-form-input input"
                placeholder={placeholder}
                maxLength={maxLength}
                onChange={this.handleCommentChange}
                rows={numberOfRows}></textarea>
              <p className="case-comment-length">
                {this.state.comment?.length}/{maxLength}
              </p>
            </>
          </Conditional>
          <div className="case-comment-buttons-group">
            <button
              onClick={this.cancelComment}
              className="chakra-secondary-button">
              Cancel
            </button>
            <button
              onClick={this.submitComment}
              className={classnames('chakra-primary-button')}>
              {submitLabel}
            </button>
          </div>
        </form>
      </Modal>
    );
  }
}

export { CaseComment };
